var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmethystLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1122_15965)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0874,
    r: 24,
    fill: "url(#paint0_linear_1122_15965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2347 33.9362L17.7159 26.1949L9.97461 22.6761L17.7159 19.1573L21.2347 11.416L24.7535 19.1573L32.4948 22.6761L24.7535 26.1949L21.2347 33.9362ZM32.4948 36.7513L30.7354 32.8806L26.8648 31.1212L30.7354 29.3618L32.4948 25.4912L34.2542 29.3618L38.1249 31.1212L34.2542 32.8806L32.4948 36.7513Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1122_15965",
    x1: -2.5,
    y1: -10.5,
    x2: 48,
    y2: 55.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#460073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A100FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_15965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.0834961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmethystLogo);
export default __webpack_public_path__ + "static/media/Amethyst Logo.7f3dffe53ec96d3ee1128718ebce94f5.svg";
export { ForwardRef as ReactComponent };